import styled from 'styled-components';
import { Row, Card } from 'antd';
import { IToken } from 'store/ducks/globalTypes';

export const ContentWrapper = styled.div<IToken & { scheme?: string }>`
  padding: 24px;
  background: ${(props) => {
    const { themesList } = require('constants/themesList');
    const currentTheme = themesList[props.scheme || 'deepBlueTheme'];
    return (
      currentTheme?.colorBgLayout || themesList.deepBlueTheme.colorBgLayout
    );
  }};
  min-height: calc(100vh - 200px);
  margin: auto;

  .ant-row {
    justify-content: center;
  }
`;

export const Title = styled.h1<IToken & { scheme?: string }>`
  color: ${(props) => {
    const darkThemes = ['darkUITheme', 'deepBlueTheme', 'deepNavyTheme'];
    return darkThemes.includes(props.scheme || '') ? '#fff' : '#000';
  }};
  margin-bottom: 16px;
  font-size: 24px;
  font-weight: 600;
`;

export const Description = styled.p<IToken & { scheme?: string }>`
  color: ${(props) => {
    const darkThemes = ['darkUITheme', 'deepBlueTheme', 'deepNavyTheme'];
    return darkThemes.includes(props.scheme || '') ? '#fff' : '#000';
  }};
  font-size: 16px;
  margin-bottom: 24px;
`;

export const DataEntryRow = styled(Row)`
  margin-top: 2rem;
`;

export const StyledCard = styled(Card)`
  text-align: center;
  height: 220px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const CardTitle = styled.h3`
  margin: 8px 0;
`;

export const CardDescription = styled.p<IToken>`
  margin: 0;
  font-size: 14px;
  color: ${({ token }) => token.colorTextSecondary};
`;
